import { BOT_MODE } from 'consts/enum';

import './chatScreen.scss';
import './fadingAnimation.scss';

export const ChatScreenTemplate = (model) => {
	const { bgStyle, videoBg, botMode } = model;

	/* html */
	const footer = `
        <div class="engt-popup-footer" id="engtChatFooter">
            <div class="engt-hidden" id="engtQuoteText"></div>
            <respond-area>
                <input-area></input-area>
            </respond-area>
            <rud-input-area></rud-input-area>
            <validated-msg></validated-msg>
            <powered-by></powered-by>
        </div>
    `;

	/* html */
	const html = `
        <div class="engt-chat-wrapper" style="${bgStyle}">
            ${videoBg}
            <div class="engt-chat-content-wrapper" id="engtChatWrapper">
                <div id="engtChatContent"  class="engt-chat-content"
                onscroll="ENGT_CHAT.checkAndfetchMessages();ENGT_CHAT.onScrollToBottom(event, this)"></div>
                <scroll-to-bottom></scroll-to-bottom>
                <typing-indicator></typing-indicator>
                ${botMode === BOT_MODE.STANDALONE ? footer : ''}
            </div>
        </div>
        ${botMode === BOT_MODE.WIDGET ? footer : ''}
    `;

	return html;
};
